module.exports = __webpack_public_path__ + "static/media/basic-full-countdown.0c16d5f9.webp";